import remove from 'lodash/remove';

class TiersContainer {
    constructor(tiers) {
        if (tiers) {
            this._tiers = this._sort(tiers);
        } else {
            this._tiers = [];
        }
    }

    length = () => {
        return this._tiers.length;
    };

    _sort = (tiers) => {
        return tiers.sort((tier1, tier2) => tier1.getPosition() - tier2.getPosition());
    };

    hasTier = (tierId) => {
        return Boolean(this.getTier(tierId));
    };

    getTiers = () => {
        return this._tiers.slice();
    };

    getTier = (tierId) => {
        return this._tiers.find((tier) => tier.getId() === tierId);
    };

    addTier = (tier) => {
        this._tiers.push(tier);
        this._tiers = this._sort(this._tiers);
    };

    removeTier = (tierId) => {
        const removedElements = remove(this._tiers, (tier) => tier.getId() === tierId);
        if (removedElements && removedElements.length) {
            return removedElements[0];
        }
        return null;
    }
}

export default (tiers) => {
    return new TiersContainer(tiers);
};



// WEBPACK FOOTER //
// ./map/tier/tiersContainer.js